import { cn } from "@/lib/utils";

export function XpBar({ progress, className }: { progress: number; className?: string }) {
  return (
    <div className={cn("h-2.5 w-full overflow-hidden rounded-full bg-xp/20", className)}>
      <div
        className="h-full rounded-full bg-gradient-to-r from-xp to-[oklch(0.8_0.17_95)] transition-[width] duration-700"
        style={{ width: `${Math.round(Math.min(1, Math.max(0, progress)) * 100)}%` }}
      />
    </div>
  );
}

export function LevelBadge({ level, className }: { level: number; className?: string }) {
  return (
    <div
      className={cn(
        "flex size-12 shrink-0 items-center justify-center rounded-2xl bg-gradient-to-br from-xp to-[oklch(0.68_0.18_45)] text-lg font-black text-xp-foreground shadow-sm",
        className,
      )}
    >
      {level}
    </div>
  );
}
